import React from "react";

interface KeywordSectionProps {
    isMobile: boolean;
    keywords: string[];
    selectedKeywords: string | null;
    toggleKeyword: (keyword: string) => void;
    keywordError?: string;
    keywordRef: React.RefObject<HTMLDivElement>;
}

const KeywordSection: React.FC<KeywordSectionProps> = ({
    isMobile,
    keywords,
    selectedKeywords,
    toggleKeyword,
    keywordError,
    keywordRef,
}) => {
    return (
        <div className={"flex flex-col gap-3"}>
            <label className={`flex flex-col gap-4 ${!isMobile ? "mt-5" : ""}`} id="authorKeyword">
                <span className="title">
                    작가님은 주로 <span className="point">어떤 글</span>을 쓰시나요?
                </span>
            </label>

            <div
                ref={keywordRef}
                className="w-full h-full border border-extra rounded-2xl shadow-sm bg-white"
            >
                <div className={`grid ${isMobile ? "grid-cols-2" : "grid-cols-3"}`}>
                    {keywords.map((keyword: string) => (
                        <div
                            key={keyword}
                            className="px-2 py-3 flex items-center justify-center w-full cursor-pointer"
                            onClick={() => toggleKeyword(keyword)}
                        >
                            <span
                                className={`${isMobile ? "font-namsan text-sm" : "font-namsan-B text-base"} leading-tight pb-0.5 ${
                                    selectedKeywords === keyword
                                        ? "text-main border-b-2 border-main font-bold inline-block"
                                        : "text-[#8B8B8B] font-medium"
                                }`}
                            >
                                {keyword}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
            {keywordError && (
                <p className="font-namsan text-[12px] font-bold text-red-500">{keywordError}</p>
            )}
        </div>
    );
};

export default KeywordSection;
